import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-box">
          <div className="cta-icon">💡</div>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem', color: 'var(--color-white)' }}>Ready to Transform Your Practice?</h2>
          <p className="cta-description">Join medical professionals who trust RuaMedical for their portal needs. Start your free trial today.</p>
          <button 
            className="btn-primary"
            onClick={() => navigate('/signup')}
            style={{ marginTop: '1.5rem' }}
          >
            Start Your Free Trial Today <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
